<template>
  <div class="home">
    <main class="home__container">
      <h1 class="home__heading">Play Avalon Online</h1>

      <avl-box class="home__container-inner">
        <h2>About The Project</h2>

        <section class="home__about">
          This is an adaptation of the board game called
          <a href="https://boardgamegeek.com/boardgame/128882/resistance-avalon" target="_blank"
            >"The Resistance: Avalon"</a
          >:

          <blockquote
            class="home__quote"
            cite="https://boardgamegeek.com/boardgame/128882/resistance-avalon"
          >
            <p class="home__paragraph">
              "The Resistance: Avalon pits the forces of Good and Evil in a battle to control the
              future of civilization.
            </p>

            <p class="home__paragraph">
              Arthur represents the future of Britain, a promise of prosperity and honor, yet hidden
              among his brave warriors are Mordred's unscrupulous minions.
            </p>

            <p class="home__paragraph">
              These forces of evil are few in number but have knowledge of each other and remain
              hidden from all but one of Arthur's servants.
            </p>

            <p class="home__paragraph">
              Merlin alone knows the agents of evil, but he must speak of this only in riddles. If
              his true identity is discovered, all will be lost."
            </p>
          </blockquote>

          <p class="home__paragraph">
            The Avalon.fun project lets you play your beloved game online, eliminating the need for
            the tedious setup phase.
          </p>

          <p class="home__paragraph">
            The platform provides both desktop and mobile experiences for your convenience. This
            makes the platform perfect for both, eye-to-eye game sessions as well as the
            over-the-network ones. See the screenshots from the game below:
          </p>

          <div class="home__screenshots">
            <img
              class="home__screenshot"
              src="../../assets/img/showcase/game-screenshot-desktop.png"
              alt="Game Screenshot: Desktop Version"
            />

            <img
              class="home__screenshot"
              src="../../assets/img/showcase/game-screenshot-mobile.png"
              alt="Game Screenshot: Mobile Version"
            />
          </div>

          <p class="home__paragraph">
            You can view the original game at
            <a href="https://boardgamegeek.com/boardgame/128882/resistance-avalon" target="_blank"
              >BoardGameGeek</a
            >.
          </p>
        </section>

        <h2>Disclaimer</h2>

        <section class="home__disclaimer">
          <p class="home__paragraph">
            This is a non-profit project made by two friends out of pure love for the original game.
            The project is not affiliated with any of the official publishers of the original game
            in any way. However, we do accept donations to offset the costs of things like the
            domain name and hosting the app.
          </p>
        </section>
      </avl-box>
    </main>

    <el-button class="home__play-now" type="success">
      <router-link class="home__play-now-link" :to="{ name: 'lobby' }">
        Play
      </router-link>
    </el-button>
  </div>
</template>

<script>
  export default {};
</script>

<style scoped lang="scss">
  .home {
    width: 100%;
    min-height: 100%;
    overflow: auto;

    &__heading {
      color: #ffffff;
      text-align: center;
    }

    &__container {
      margin: 0 auto;
      width: 93.75%;
      @include tablet-lg() {
        width: 800px;
      }
      @include desktop-sm() {
        width: 1024px;
      }
    }

    &__container-inner {
      padding: 12px;
      @include phone-lg() {
        padding: 24px;
      }
      @include tablet-sm() {
        padding: 32px;
      }
    }

    &__quote {
      line-height: 1.5;
      font-size: 14px;
    }

    &__paragraph {
      font-size: 16px;
    }

    &__screenshots {
      width: 100%;
      text-align: center;
      margin: 32px 0;
      //
      height: auto;
      @include tablet-sm() {
        height: 400px;
      }
    }

    &__screenshot {
      display: inline-block;
      vertical-align: middle;
      //
      margin: 12px 0;
      max-height: 400px;
      max-width: 100%;
      @include tablet-sm() {
        margin: 0 24px;
        max-height: 100%;
        max-width: 50%;
      }
    }

    &__play-now {
      box-shadow: 0 8px 16px -1px rgba(10, 31, 68, 0.3);
      position: fixed;
      bottom: 16px;
      right: 16px;
      //
      padding: 0 !important;
      border-radius: 50% !important;
      text-align: center;
      //
      width: 42px;
      height: 42px;
      font-size: 12px;
      @include phone-lg() {
        width: 56px;
        height: 56px;
        font-size: 16px;
      }
    }

    &__play-now-link {
      width: 100%;
      height: 100%;
      color: #ffffff;
      display: flex;
      align-items: center;
      justify-content: center;
      //
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
</style>
